import type { FC } from 'react';

import { Box, Col, Text } from '@opendoor/bricks-next';
import { Button } from 'platform/bricks-next';

interface IDownloadAppProps {
  handleOnNext: () => void;
}

/**
 * Download app step
 *
 */
export const DownloadApp: FC<IDownloadAppProps> = ({ handleOnNext }) => {
  return (
    <Col alignItems="center" gap="$4x" flex={1}>
      <Box display="block" mb="$8x">
        <Text tag="h2" typography="$subheaderLarge" mb="$4x" $platform-web={{ fontWeight: 700 }}>
          Get the app to tour this home
        </Text>
      </Box>
      <Text tag="p" typography="$bodyMedium">
        Tour any day from 8:00am to 7:30pm. Unlock the door with the Opendoor app.
      </Text>
      <Button
        variant="primary"
        analyticsName="cake-tour-creation-flow-download-app"
        aria-label="Get the app"
        onClick={handleOnNext}
        mt={3}
        label="Get the app"
        size="large"
      />
    </Col>
  );
};
